import { Modal } from '@/components/ui/Modal'
import { PARCEIROS_ACCENT, fieldClass, labelClass } from './parceirosBrand'
import { useParceirosLeadEdit } from './useParceirosLeadEdit'
import type { PortalReferral } from '@/services/referralsService'

type Props = {
  row: PortalReferral | null
  onClose: () => void
  onSaved: () => Promise<void> | void
}

export function ParceirosLeadEditModal({ row, onClose, onSaved }: Props) {
  const form = useParceirosLeadEdit(row, async () => {
    await onSaved()
    onClose()
  })

  return (
    <Modal
      open={Boolean(row)}
      onClose={onClose}
      title={row?.empresa || 'Contato'}
      description={
        form.canEdit
          ? 'Atualize os dados do contato indicado.'
          : 'Este contato já está em negociação. Os dados ficam só para consulta.'
      }
      size='lg'
    >
      <form onSubmit={form.submit} className='grid gap-4'>
        <div className='grid gap-4 md:grid-cols-2'>
          <label className='grid gap-1.5'>
            <span className={labelClass}>Nome do contato</span>
            <input
              className={fieldClass}
              value={form.values.nome}
              onChange={(e) => form.patch('nome', e.target.value)}
              required
              minLength={2}
              maxLength={255}
              disabled={!form.canEdit}
            />
          </label>
          <label className='grid gap-1.5'>
            <span className={labelClass}>Empresa</span>
            <input
              className={fieldClass}
              value={form.values.empresa}
              onChange={(e) => form.patch('empresa', e.target.value)}
              required
              minLength={2}
              maxLength={255}
              disabled={!form.canEdit}
            />
          </label>
          <label className='grid gap-1.5'>
            <span className={labelClass}>Telefone</span>
            <input
              className={fieldClass}
              value={form.values.telefone}
              onChange={(e) => form.patch('telefone', e.target.value)}
              required
              minLength={8}
              maxLength={20}
              inputMode='tel'
              disabled={!form.canEdit}
            />
          </label>
          <label className='grid gap-1.5'>
            <span className={labelClass}>E-mail</span>
            <input
              className={fieldClass}
              type='email'
              value={form.values.email}
              onChange={(e) => form.patch('email', e.target.value)}
              maxLength={255}
              disabled={!form.canEdit}
            />
          </label>
          <label className='grid gap-1.5 md:col-span-2'>
            <span className={labelClass}>Site</span>
            <input
              className={fieldClass}
              value={form.values.site}
              onChange={(e) => form.patch('site', e.target.value)}
              maxLength={500}
              placeholder='https://loja.com.br'
              disabled={!form.canEdit}
            />
          </label>
          <label className='grid gap-1.5 md:col-span-2'>
            <span className={labelClass}>Observação</span>
            <textarea
              className={`${fieldClass} min-h-24 resize-y`}
              value={form.values.observacao}
              onChange={(e) => form.patch('observacao', e.target.value)}
              maxLength={500}
              disabled={!form.canEdit}
            />
          </label>
        </div>

        {form.error && <p className='text-sm text-red-500'>{form.error}</p>}

        <div className='flex justify-end gap-2'>
          <button
            type='button'
            onClick={onClose}
            className='rounded-full border border-[var(--glass-border)] px-4 py-2 text-sm text-text-muted hover:text-text-primary'
          >
            {form.canEdit ? 'Cancelar' : 'Fechar'}
          </button>
          {form.canEdit && (
            <button
              type='submit'
              disabled={form.submitting}
              className='rounded-full px-4 py-2 text-sm font-medium text-white active:scale-95 disabled:opacity-50'
              style={{ background: PARCEIROS_ACCENT }}
            >
              {form.submitting ? 'Salvando…' : 'Salvar contato'}
            </button>
          )}
        </div>
      </form>
    </Modal>
  )
}
